<template>
  <AcademicCardsChapter
    page-title="调研活动"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhudiaoyanhuodong',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '田野采访与基层调研',
          summary: '研究所长期将新闻史调查、基层社会观察与媒体机构调研结合起来，形成了多种类型的田野工作样本。',
          columns: 2,
          cards: [
            {
              title: '1985 年延安采访',
              src: require('./assets/html/fieldwork-1985-yanan.jpg'),
              description: '1985 年 10 月，延安解放日报史课题组一行赴延安采访。图为王敬、王凤超到陕北访问当年大生产劳动中人称“气死牛”的劳模英雄郝树才。'
            },
            {
              title: '2007 年北京皮村小记者培训',
              src: require('./assets/html/fieldwork-2007-picun.jpg'),
              description: '2007 年，卜卫在北京皮村为流动儿童开展小记者培训。'
            },
            {
              title: '2006 年牡丹江传媒集团调研',
              src: require('./assets/html/fieldwork-2006-mudanjiang.jpg'),
              description: '2006 年 9 月，张昌东带队在牡丹江传媒集团调研。'
            },
            {
              title: '2018 年兰考县杜寨村实地考察',
              src: require('./assets/html/fieldwork-2018-lankao.jpg'),
              description: '2018 年 6 月，“改革开放四十年百县（市、区）调查”赵天晓率新闻与传播研究所课题组在河南省兰考县葡萄架乡杜寨村实地考察。'
            },
            {
              title: '2018 年张家港市永联村调研',
              src: require('./assets/html/fieldwork-2018-yonglian.jpg'),
              description: '2018 年 6 月，“改革开放四十年百县（市、区）调查”唐绪军率新闻与传播研究所课题组在江苏省张家港市永联村调研。'
            }
          ]
        }
      ]
    };
  }
};
</script>
